export const styles = {
  container:
    'flex flex-row justify-center items-center w-full max-w-4xl mx-auto my-8 flex-wrap lg:flex-nowrap lg:flex-col lg:items-stretch lg:max-w-full lg:mx-0 lg:my-4',

  group: 'flex flex-col items-center mx-1 lg:mx-0 mb-6 lg:mb-0',
  groupLast: 'flex flex-col items-center mx-1 lg:mx-0',

  groupTitle: 'text-xl font-semibold mb-1 text-center lg:text-lg',

  boxContainer:
    'flex flex-row items-center gap-3 py-2 w-auto content-center lg:flex-col lg:gap-6 lg:items-center lg:w-full lg:flex-nowrap lg:py-2 lg:gap-2',

  box: 'mx-1 py-2 px-3 rounded-lg border-2 border-gray-400 flex flex-col items-center w-36 max-w-36 min-w-36 h-auto box-border text-center bg-white',

  number: 'text-lg lg:text-2xl font-bold leading-tight mb-1 lg:text-xl',

  label: 'text-sm lg:text-lg text-center text-gray-800',

  arrow: 'w-8 lg:mx-auto lg:my-2 lg:transform',
} as const;
